module.exports = __webpack_public_path__ + "img/guidance_for_repackers.f3d3dc85.jpg";